import React, { useEffect, useState } from "react";
import {
  ButtonContain,
  Card,
  CardContain,
  TabsContain,
} from "../../style/Home";
import Grid from "@mui/material/Grid";
import Filter from "../../Components/filters";
import { useDispatch, useSelector } from "react-redux";
import { resetFilter } from "../../features/filterSlice";
import ExcelIcon from "../../assets/images/icons/excel.png";
import {
  CommanTableContain,
} from "../../style/table";
import {
  Table,
  TableBody,
  TableFooter,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Tab,
  Tabs,
  Menu,
  MenuItem,
} from "@mui/material";
import { GetExcelFile, UpdateReportList } from "../../services/hoReportService";
import { toast, ToastContainer } from "react-toastify";
import "../../css/hoReport.css";
import { Loader } from "../../utils/loader";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { MeData } from "../../services/MeServices";
import { Colors } from "../../style/theme";

function HoReport() {
  const [filterValues, setFilterValues] = useState({});
  const [defaultTab, setDefaultTab] = useState({});
  const [loader, setLoader] = useState(false);
  const filtersValue = useSelector((state) => state.filterData);
  const [resetTrigger, setResetTrigger] = useState(Date.now());
  const dispatch = useDispatch();
  const [isDispatched, setIsDispatched] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableHeading, setTableHeading] = useState([]);
  const [tableFooter, setTableFooter] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fileType, setFileType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState('')
  const open = Boolean(anchorEl);
  const [reportList, setReportList] = useState([]);
  const [checkValue, setCheckValue] = useState(0);
  
  const getUserData = async () => {
    try {
      const userData = await MeData();
      if (userData?.success) {
        let filterData = UpdateReportList(userData?.user?.roleType);
        setReportList(filterData);
        setDefaultTab(filterData[0]);
      }
    } catch (error) {
      console.log("error: ", error);
      toast.error("Network Error");
    }
  };
  
  useEffect(()=>{
    getUserData();
  }, [])
  
  useEffect(() => {
    dispatch(resetFilter());
    setIsDispatched(true);
  }, [dispatch]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const GetReportData = async () => {
    try {
      setLoader(true);
      const payload = {
        mimeType: "json",
        financialYear: filtersValue.financialYear || [],
        period: filtersValue.period || [],
        dealerCodes: filtersValue.dealerCodes || [],
        regions: filtersValue.regions || [],
        zones: filtersValue.zones || [],
        areas: filtersValue.areas || [],
        group: selectedGroup?.toLowerCase() || ""
      };
      const response = await GetExcelFile({
        selectedTab: defaultTab,
        payload: payload,
      });
      if (response?.success) {
        setTableHeading(response?.heading);
        setTableData(response?.data || []);
        setTableFooter(response?.footer || []);
      }
    } catch (error) {
      console.log("Failed to load reporting data: ", error);
      toast.error("Network Error");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (defaultTab && Object.keys(defaultTab).length > 0) {
      GetReportData();
    }
  }, [isDispatched, resetTrigger, defaultTab]);

  const handleChange = (event, newValue) => {
    setDefaultTab(newValue);
    setCheckValue(checkValue + 1);
  };


const handleSelectedGroup = (e) => {
    setSelectedGroup(e.target.value);
};

useEffect(() => {
    if (selectedGroup && defaultTab?.showFilter) {
        GetReportData();
    }
}, [selectedGroup]);


  const handleFilterChange = (filterKey, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [filterKey]: value,
    }));
  };

  const handleSearch = async () => {
    await GetReportData();
  };

  const handleReset = () => {
    dispatch(resetFilter());
    setResetTrigger(Date.now());
    setTimeout(() => setResetTrigger(false), 0);
  };

  const handleDownload = async (mimeType) => {
    try {
      setIsLoading(true);
      const payload = {
        mimeType,
        financialYear: filtersValue.financialYear || [],
        period: filtersValue.period || [],
        dealerCodes: filtersValue.dealerCodes || [],
        regions: filtersValue.regions || [],
        zones: filtersValue.zones || [],
        areas: filtersValue.areas || [],
        group: selectedGroup?.toLowerCase() || ""
      };

      const response = await GetExcelFile({
        selectedTab: defaultTab,
        payload: payload,
      });

      if (response?.success && response?.url) {
        const link = document.createElement("a");
        link.href = response.url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Failed to download file. Please try again.");
    } finally {
      setIsLoading(false);
      setFileType("");
      setSelectedValue("");
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />

      <CardContain>
        <Card mt={1} className="Filter_bg">
          <Grid container spacing={1}>
            <Filter
              onFilterChange={handleFilterChange}
              reset={resetTrigger}
            ></Filter>
            <Grid item xs={12}>
              <ButtonContain>
                <button onClick={handleSearch} className="SearchButton">
                  Search
                </button>
                <button onClick={handleReset} className="ResetButton">
                  Reset
                </button>
              </ButtonContain>
            </Grid>
          </Grid>
        </Card>
      </CardContain>

      {/* define downloading reporting tabs */}
      <TabsContain className="TabsContain">
        <Tabs
          value={defaultTab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable force tabs example"
          sx={{
            bgcolor: "#708090",
            marginTop: "15px",
            marginBottom: "15px",
            color: "#fff",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            "& .Mui-selected.MuiButtonBase-root": {
              color: "#fff",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: Colors.primary,
            },
          }}
        >
          {reportList.map((tab, index)=>(
            tab.showTab && <Tab label={tab.label} value={tab} style={{color: '#fff'}}/>
          ))}
        </Tabs>
      </TabsContain>

      <CardContain>
      <div className="import_btn" style={{
          display: "flex",
          justifyContent: "space-between"
        }}>
          <Card>
          {Boolean(defaultTab?.showFilter && defaultTab?.filterList?.length) && (
            <select name="groupBy" id="groupBy" style={{ padding: "5px", borderRadius: "5px" }} onChange={handleSelectedGroup}>
              {defaultTab?.filterList.map((data, dataIndex) => (
                <option key={dataIndex} value={data}>
                  {data}
                </option>
              ))}
            </select>
          )}
          </Card>

          {tableData.length > 0 && (
            <Card>
              <div className="import_btn_xcel">
                <Button
                  variant="contained"
                  onClick={handleClick}
                  endIcon={<KeyboardArrowDownIcon />}
                >
                  <img src={ExcelIcon} alt="Excel icon" />
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  disableScrollLock
                >
                  <MenuItem onClick={() => handleDownload("csv")}>
                    Download CSV
                  </MenuItem>
                  <MenuItem onClick={() => handleDownload("xlsx")}>
                    Download Excel
                  </MenuItem>
                </Menu>
              </div>
            </Card>
          )}
        </div>

        {/* table for preview */}
        <Card mt={2}>
          <CommanTableContain>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {tableHeading.map((heading, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        position: "sticky",
                        top: 0,
                        left: index === 0 ? 0 : "initial",
                        backgroundColor: "white",
                        zIndex: index === 0 ? 11 : 10,
                      }}
                    >
                      {heading}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {tableData.map((reportData, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {reportData.map((cellData, cellIndex) => (
                      <TableCell
                        key={cellIndex}
                        sx={{
                          position: "sticky",
                          left: cellIndex === 0 ? 0 : "initial",
                          backgroundColor: "white",
                          zIndex: cellIndex === 0 ? 10 : 9,
                        }}
                      >
                        {cellData}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                {/* {tableData.length > 0 ? (
                
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeading.length} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )} */}
              </TableBody>

              <TableFooter>
                <TableRow>
                  {tableFooter.length > 0 ? (
                    tableFooter.map((footer, index)=>(
                      <TableCell
                        key={index}
                        sx={{
                          position: "sticky",
                          left: index === 0 ? 0 : "initial",
                          zIndex: index === 0 ? 10 : 9,
                        }}
                        className="footerColorChange"
                      >
                        {footer}
                      </TableCell>
                    ))
                  ) : ""}
                </TableRow>
              </TableFooter>
            </Table>
          </CommanTableContain>
        </Card>
      </CardContain>
      {loader && <Loader fullScreen={true} />}
    </>
  );
}

export default HoReport;
